import React from "react";

export default function Select({
  fill = "white",
  width = "12",
  height = "12",
  clicked = false,
  ...others
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ pointerEvents: clicked ? 'none' : '' }}
      {...others}>
      <path
        d='M4.4849 7.32861L6.3449 9.19067C6.6313 9.47739 7.125 9.27237 7.125 8.86207V7.79241H10.3333C10.7692 7.79241 11.125 7.43598 11.125 7C11.125 6.56402 10.7692 6.20759 10.3333 6.20759H7.125V5.13853V5.13793H7L4.4849 7.32861ZM4.4849 7.32861C4.30281 7.14632 4.30281 6.86035 4.4849 6.67807M4.4849 7.32861V6.67807M4.4849 6.67807L6.3443 4.81659L4.4849 6.67807ZM2.33333 0.875H9.66667C10.4692 0.875 11.125 1.53176 11.125 2.33482V4.33037C11.125 4.76635 10.7692 5.12278 10.3333 5.12278C9.8975 5.12278 9.54167 4.76635 9.54167 4.33037V2.98888C9.54167 2.69071 9.2975 2.44647 9 2.44647H3C2.7025 2.44647 2.45833 2.69071 2.45833 2.98888V11.0178C2.45833 11.316 2.7025 11.5602 3 11.5602H9C9.2975 11.5602 9.54167 11.316 9.54167 11.0178V9.66963C9.54167 9.23365 9.8975 8.87722 10.3333 8.87722C10.7692 8.87722 11.125 9.23365 11.125 9.66963V11.6785C11.125 12.4749 10.4758 13.125 9.68 13.125H2.33333C1.53083 13.125 0.875 12.4682 0.875 11.6652V2.33482C0.875 1.53176 1.53083 0.875 2.33333 0.875Z'
        fill={fill}
        stroke='white'
        strokeWidth='0.25'
      />
    </svg>
  );
}
